export const DEFAULT_EVENT_TIMEZONE = 'America/New_York';

export const EVENT_TIMEZONES = [
  { value: 'America/New_York', es: 'Este (ET)', en: 'Eastern (ET)' },
  { value: 'America/Chicago', es: 'Central (CT)', en: 'Central (CT)' },
  { value: 'America/Denver', es: 'Montaña (MT)', en: 'Mountain (MT)' },
  { value: 'America/Phoenix', es: 'Arizona (MST, sin cambio de hora)', en: 'Arizona (MST, no daylight saving)' },
  { value: 'America/Los_Angeles', es: 'Pacífico (PT)', en: 'Pacific (PT)' },
  { value: 'America/Anchorage', es: 'Alaska (AKT)', en: 'Alaska (AKT)' },
  { value: 'Pacific/Honolulu', es: 'Hawái (HST)', en: 'Hawaii (HST)' },
  { value: 'America/Puerto_Rico', es: 'Puerto Rico (AST)', en: 'Puerto Rico (AST)' }
];

const STATE_TIMEZONES = {
  AL: 'America/Chicago', AK: 'America/Anchorage', AR: 'America/Chicago', AZ: 'America/Phoenix',
  CA: 'America/Los_Angeles', CO: 'America/Denver', CT: 'America/New_York', DC: 'America/New_York',
  DE: 'America/New_York', FL: 'America/New_York', GA: 'America/New_York', HI: 'Pacific/Honolulu',
  IA: 'America/Chicago', ID: 'America/Denver', IL: 'America/Chicago', IN: 'America/New_York',
  KS: 'America/Chicago', KY: 'America/New_York', LA: 'America/Chicago', MA: 'America/New_York',
  MD: 'America/New_York', ME: 'America/New_York', MI: 'America/New_York', MN: 'America/Chicago',
  MO: 'America/Chicago', MS: 'America/Chicago', MT: 'America/Denver', NC: 'America/New_York',
  ND: 'America/Chicago', NE: 'America/Chicago', NH: 'America/New_York', NJ: 'America/New_York',
  NM: 'America/Denver', NV: 'America/Los_Angeles', NY: 'America/New_York', OH: 'America/New_York',
  OK: 'America/Chicago', OR: 'America/Los_Angeles', PA: 'America/New_York', PR: 'America/Puerto_Rico',
  RI: 'America/New_York', SC: 'America/New_York', SD: 'America/Chicago', TN: 'America/Chicago',
  TX: 'America/Chicago', UT: 'America/Denver', VA: 'America/New_York', VT: 'America/New_York',
  WA: 'America/Los_Angeles', WI: 'America/Chicago', WV: 'America/New_York', WY: 'America/Denver'
};

export const timezoneForState = (state = '') => STATE_TIMEZONES[String(state || '').trim().toUpperCase()] || DEFAULT_EVENT_TIMEZONE;
export const eventTimezone = (event) => event.timezone || DEFAULT_EVENT_TIMEZONE;
export const eventTimezoneLabel = (zone, language = 'es') =>
  EVENT_TIMEZONES.find(item => item.value === zone)?.[language === 'es' ? 'es' : 'en'] || zone;

// Compare wall clock values in the event's zone, independent of the viewer's browser zone.
export const isEventPast = (event, now = new Date()) => {
  if (!event.date) return false;
  const parts = new Intl.DateTimeFormat('en-US', {
    timeZone: eventTimezone(event), year: 'numeric', month: '2-digit', day: '2-digit',
    hour: '2-digit', minute: '2-digit', hourCycle: 'h23'
  }).formatToParts(now);
  const values = Object.fromEntries(parts.map(part => [part.type, part.value]));
  const current = `${values.year}-${values.month}-${values.day}T${values.hour}:${values.minute}`;
  return `${event.date}T${event.time || '23:59'}` < current;
};
